import { render, staticRenderFns } from "./BDXManagementTableFiltersPendingReserves.vue?vue&type=template&id=0a8632e8"
import script from "./BDXManagementTableFiltersPendingReserves.vue?vue&type=script&lang=js"
export * from "./BDXManagementTableFiltersPendingReserves.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports